module.exports = __webpack_public_path__ + "static/media/dropdown_icon.18bc3d42.svg";